// extracted by mini-css-extract-plugin
module.exports = {"outer":"I85Om","heading":"_2s2kC","subHeading":"_322pY","newCarsAdded":"wPLJA"};